import { render, staticRenderFns } from "./filterTag.vue?vue&type=template&id=72bb0cde&scoped=true&"
import script from "./filterTag.vue?vue&type=script&lang=js&"
export * from "./filterTag.vue?vue&type=script&lang=js&"
import style0 from "./filterTag.vue?vue&type=style&index=0&id=72bb0cde&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bb0cde",
  null
  
)

export default component.exports